import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Button, Form, Dropdown } from "semantic-ui-react";
import { Container, Content, Title } from "./styles";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import CursosSelector from "../../../../components/Admin/CursosSelector";
import swal from "sweetalert";

const iconOptions = [
  {
    key: "presente",
    value:
      "https://files.voitto.com.br/icons/BirthdayTicketIcon.png",
    text: "Presente",
    image: {
      src:
        "https://files.voitto.com.br/icons/BirthdayTicketIcon.png",
    },
  },
  {
    key: "ticket",
    value:
      "https://files.voitto.com.br/ftp-files/assets/images/ticket_icon.png",
    text: "Ticket",
    image: {
      src:
        "https://files.voitto.com.br/ftp-files/assets/images/ticket_icon.png",
    },
  },
];

const CursoIncompletoNotificacao = () => {
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [message, setMessage] = useState("");
  const [idAlunos, setIdAlunos] = useState([]);
  const [icon, setIcon] = useState("");
  const [curso, setCurso] = useState(null);
  const [dateStart, setDateStart] = useState('');
  const [dateEnd, setDateEnd] = useState('');

  useEffect(() => {
    if (!curso) return

    const formatDate = (start, end) => {
      if (!start || !end) return '';
      return `dateStart=${start}&dateEnd=${end}`;
    }

    api.get(`/alunos/curso/${curso}/incompleto?${formatDate(dateStart, dateEnd)}`)
      .then(res => {
        setIdAlunos(res.data)
      }).catch(err => {
        console.error(err)
      })
  }, [curso, dateStart, dateEnd])



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (idAlunos.length === 0) {
      swal({
        title: "Nenhum aluno encontrado",
        icon: "error",
      });
      return;
    }

    if (!title || !subtitle || !message || !icon) {
      swal({
        title: "Preencha todos os campos",
        icon: "error",
      });
      return;
    }

    const destiny = `["${idAlunos.map(id => id.toString()).join(',')}"]`;

    const data = {
      title,
      subtitle,
      message,
      action: 'assistir',
      actionData: curso,
      ticker: "",
      statusReaded: "[]",
      statusReceived: "[]",
      statusCleaned: "[]",
      destiny: destiny.replace(/,/g, `\",\"`),
      icon: JSON.stringify({ type: "image", value: icon }),
    };


    await api
      .post("notificacoes/push", data)
      .then((res) => {

        const logs = {
          local: "notificacoes/cursoEmAndamento",
          texto: `Criou uma notificação para os aluno com progresso em andamento no curso ${curso} (id da notificação criada: ${res.data.id})`,
          alunos: idAlunos,
          parametros: {
            curso,
            dateStart,
            dateEnd
          }
        };

        api.post("system_logs", { acao: JSON.stringify(logs) });

        swal({
          title: "Notificação criado com sucesso",
          icon: "success",
        });
      })
      .catch((err) => {
        console.error(err);
        swal("Algo deu errado na criação da notificação", "", "error");
      });
  };

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Title>Criar Notificação por curso em andamento</Title>
          <Form onSubmit={handleSubmit}>
            <CursosSelector handleChange={setCurso} />

            <Form.Group>
              <Form.Field>
                <strong>De:</strong>
                <div className="ui input fluid">
                  <input
                    type="date"
                    onChange={(e) => setDateStart(e.target.value)}
                    value={dateStart}
                  />
                </div>
              </Form.Field>
              <Form.Field>
                <strong>Até:</strong>
                <div className="ui input fluid">
                  <input
                    type="date"
                    onChange={(e) => setDateEnd(e.target.value)}
                    value={dateEnd}
                  />
                </div>
              </Form.Field>
            </Form.Group>

            {idAlunos.length > 0 && (
              <div>
                Total de alunos encontrados: {idAlunos.length}
              </div>
            )}
            <Form.Input
              label="Título da Mensagem"
              placeholder="Título da Mensagem"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />

            <Form.Input
              label="Subtitulo da Mensagem"
              placeholder="Subtitulo da Mensagem"
              value={subtitle}
              onChange={(e) => {
                setSubtitle(e.target.value);
              }}
            />

            <Form.Input
              label="Conteúdo da mensagem"
              placeholder="Conteúdo da Mensagem"
              value={message}
              onChange={(e) => {
                setMessage(e.target.value);
              }}
            />

            <Form.Field>
              <label>Selecionar ícone</label>
              <Dropdown
                placeholder="Ícones"
                fluid
                selection
                clearable
                options={iconOptions}
                onChange={(e, data) => setIcon(data.value)}
              />
            </Form.Field>

            <Button primary type="submit">
              Criar
            </Button>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default CursoIncompletoNotificacao;
